import {InjectionToken} from "@angular/core";
import type {StateService} from "@uirouter/angularjs";

/** Definerer metoder fra ajs @uirouter {@link StateService} som vi benytter i ng2-koden */
export interface AjsStateService extends Pick<StateService, 'go' | 'href'> {
}

export const ajs_$state_DI_TOKEN = new InjectionToken<AjsStateService>('ajs $state');
